import { Navigate, Outlet } from "react-router-dom";
import { useStarterLayoutController } from "./controllers/useStarterLayoutController";
import { LoadingOverlay } from "../../../components";
import StarterSidebar from "./components/StarterSidebar";
import StarterHeader from "./components/StarterHeader";
import StarterFooter from "./components/StarterFooter";
import { MainAppsRepo } from "../../../Apps";
import { FC } from "react";

interface StarterAppLayoutProps {
  changeApp?: (app: MainAppsRepo) => void;
}

const StarterAppLayout: FC<StarterAppLayoutProps> = ({ changeApp }) => {
  // Controllers
  const { state: starterLayoutState } = useStarterLayoutController();

  // States
  const loading = starterLayoutState.loading;
  const isAuthenticated = starterLayoutState.isAuthenticated;

  // Views
  if (!loading && !isAuthenticated) {
    return <Navigate to="/starter/login" replace />;
  }

  if (loading) {
    return (
      <div className="text-center">
        <LoadingOverlay isOpen={true} />
      </div>
    );
  }

  // Layout
  return (
    <div>
      <StarterSidebar changeApp={changeApp} />
      <div className="wrapper d-flex flex-column min-vh-100 bg-light dark:bg-transparent">
        <StarterHeader />
        <div className="body flex-grow-1 px-3">
          <Outlet />
        </div>
        <StarterFooter />
      </div>
    </div>
  );
};

export default StarterAppLayout;
